export function generateCalendarDemoData(language, timeFormat) {
  const lang = language || 'sv';
  const format = timeFormat || '24h';
  const now = new Date();
  const events = [];

  const eventTemplates = [
    { dayOffset: 0, start: '09:00', end: '11:00', title: 'Fastighetsunderhåll' },
    { dayOffset: 0, start: '11:00', end: '13:00', title: 'Hyresgästmöte - Våning 3' },
    { dayOffset: 0, start: '13:00', end: '15:00', title: 'Hissbesiktning' },
    { dayOffset: 0, start: '16:00', end: '18:00', title: 'Konferensrum A Bokad' },
    { dayOffset: 0, start: '19:00', end: '20:00', title: 'Städning av Entré' },
    { dayOffset: 0, start: '21:00', end: '22:00', title: 'Säkerhetsrond' },
    { dayOffset: 0, start: '22:00', end: '23:00', title: 'Ventilationskontroll' },
    // Day 2 - EMPTY (no events to show empty day UI)
    { dayOffset: 2, start: '11:00', end: '13:00', title: 'Brandskyddsövning' },
    { dayOffset: 2, start: '15:00', end: '17:00', title: 'Parkeringsunderhåll' },
    { dayOffset: 3, start: '10:00', end: '12:00', title: 'Takbesiktning' },
    { dayOffset: 3, start: '13:00', end: '15:00', title: 'Renovering Gemensamma Utrymmen' },
    { dayOffset: 3, start: '16:00', end: '18:00', title: 'Service av Gymutrustning' },
    { dayOffset: 4, start: '09:00', end: '11:00', title: 'Fönsterputs - Alla Våningar' },
    { dayOffset: 4, start: '12:00', end: '14:00', title: 'Rörinspektering' },
    { dayOffset: 4, start: '15:00', end: '17:00', title: 'Trädgårdsskötsel' },
  ];

  const monthNames = {
    sv: ['JAN', 'FEB', 'MAR', 'APR', 'MAJ', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEC'],
    en: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
  };

  const weekdayNames = {
    sv: ['SÖNDAG', 'MÅNDAG', 'TISDAG', 'ONSDAG', 'TORSDAG', 'FREDAG', 'LÖRDAG'],
    en: ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'],
  };

  const selectedLang = lang === 'en' ? 'en' : 'sv';

  const parseTime = function (timeStr) {
    const timeParts = timeStr.split(':');
    const hours = Number(timeParts[0]);
    const minutes = Number(timeParts[1]);
    return { hours: hours, minutes: minutes };
  };

  const formatTime = function (timeStr, timeFormat) {
    const timeParts = timeStr.split(':');
    const hours = Number(timeParts[0]);
    const minutes = Number(timeParts[1]);

    if (timeFormat === '12h') {
      const period = hours >= 12 ? 'PM' : 'AM';
      const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
      const paddedMinutes = minutes < 10 ? '0' + minutes : minutes.toString();
      return displayHours + ':' + paddedMinutes + ' ' + period;
    }

    return timeStr;
  };

  eventTemplates.forEach(function (template) {
    const eventDate = new Date(now);
    eventDate.setDate(now.getDate() + template.dayOffset);

    const startTime = parseTime(template.start);
    const endTime = parseTime(template.end);

    const startDate = new Date(eventDate);
    startDate.setHours(startTime.hours, startTime.minutes, 0, 0);

    const endDate = new Date(eventDate);
    endDate.setHours(endTime.hours, endTime.minutes, 0, 0);

    events.push({
      dateMonth: monthNames[selectedLang][eventDate.getMonth()],
      dateDay: eventDate.getDate().toString(),
      dateWeekday: weekdayNames[selectedLang][eventDate.getDay()],
      start: formatTime(template.start, format),
      end: formatTime(template.end, format),
      title: template.title,
      subtitle: 'SFGAB Gemensamhetslokal Smaragden',
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    });
  });

  return events;
}
